import React from 'react';
import LPHeader from '../LPHeader/LPHeader';
import Footer from '../Footer/Footer';
import TermsAndService from '../../Dashboard/Auth/SignUp/SignUpForm/Terms';




class Terms extends React.Component {
    render() {


        return (
            <div >
                <LPHeader />
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-8 col-lg-10 col-md-9">
                            <div className="card o-hidden border-0 shadow-lg my-5">
                                <div className="card-body p-0">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="p-5">
                                                <div className="text-center">
                                                    <h1 className="subtitle">Terms and Conditions</h1>
                                                </div>
                                                <TermsAndService />
                                                {/* <div className="text-center mt-3">
                                                    <h1 className="subtitle">Privacy Policy</h1>
                                                </div>
                                                <PrivacyPolicy /> */}
                                                {/* <div className="text-center mt-5">
                                                    <a href="#" className="solidbtn btn">I agree to Terms and Conditions and
											Privacy Policy</a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />

            </div >
        );
    }
}

export default Terms;